module.exports = __webpack_public_path__ + "static/media/special-indiana.3304f531.png";